export default __webpack_public_path__ + "static/media/thrasher-brand.7c81e921.png";